'use client';
import React from 'react';
import { motion } from 'motion/react';

const PALETTE = [
  '#FCD2C3', // soft peach
  '#BBD8E6', // light blue
  '#AED8C7', // mint green
  '#F2D5A3', // warm beige
  '#D8D1C2', // stone grey
];

export function ColourfulText({ text }: { text: string }) {
  const [currentColor, setCurrentColor] = React.useState(PALETTE[0]);
  const [tick, setTick] = React.useState(0); // forces re-stagger to re-run

  React.useEffect(() => {
    const pickNext = () => {
      // ensure the next color differs from the current one
      const candidates = PALETTE.filter((c) => c !== currentColor);
      const next = candidates[Math.floor(Math.random() * candidates.length)] || currentColor;
      setCurrentColor(next);
      setTick((t) => t + 1);
    };

    const id = setInterval(pickNext, 5000);
    return () => clearInterval(id);
     
  }, [currentColor]);

  return (
    <>
      {text.split('').map((char, index) => (
        <motion.span
          key={`${char}-${tick}-${index}`}
          initial={{ y: 0 }}
          animate={{
            color: currentColor,            // <- one color for all chars
            y: [0, -3, 0],
            scale: [1, 1.01, 1],
            filter: ['blur(0px)', 'blur(5px)', 'blur(0px)'],
            opacity: [1, 0.8, 1],
          }}
          transition={{
            duration: 0.5,
            delay: index * 0.05,            // keeps the wave effect
          }}
          className="inline-block whitespace-pre font-sans tracking-tight"
        >
          {char}
        </motion.span>
      ))}
    </>
  );
}
